import React, { useState } from 'react'
import { Tabs, Tab } from '@material-ui/core'
import { makeStyles } from '@material-ui/core/styles'
import { CenteredLayout } from './shared/CenteredLayout'
import Search from '../components/userConfiguration/Search'
import UserPermissionGroups from '../components/userConfiguration/permissionGroups/PermissionGroups'
import { ContentTitle } from '../components/shared/ContentTitle'

const useStyles = makeStyles(() => ({
    tabs: {
        border: '1px solid #ccc',
        backgroundColor: '#fff',
        marginBottom: '10px',
    },
    bodySection: {
        marginBottom: '30px',
    },
}))

export function UserConfigurationPage() {
    const classes = useStyles()
    const tabValues = {
        SEARCH: 0,
        USER_PERMISSION_GROUPS: 1,
    }

    const [tabValue, setTabValue] = useState(tabValues.SEARCH)

    const handleTabChange = (event, newValue) => {
        setTabValue(newValue)
    }

    const TabView = () => {
        switch (tabValue) {
            case tabValues.SEARCH:
                return <Search />
            case tabValues.USER_PERMISSION_GROUPS:
                return <UserPermissionGroups />
            default:
                return <Search />
        }
    }

    return (
        <CenteredLayout>
            <ContentTitle pageTitle={'User'} />

            <div
                style={{ justifyContent: 'center' }}
                className={classes.topBarSection}>
                <Tabs
                    value={tabValue}
                    onChange={handleTabChange}
                    indicatorColor='secondary'
                    textColor='secondary'
                    variant='fullWidth'
                    className={classes.tabs}>
                    <Tab label='Search' />
                    <Tab label='User Permission Groups' />
                </Tabs>
            </div>
            <div className={classes.bodySection}>
                <TabView />
            </div>
        </CenteredLayout>
    )
}
